import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import { IonHeader, IonToolbar, IonBackButton, IonTitle, IonButton, IonIcon, IonContent, IonItem, IonLabel, IonList, IonListHeader, IonNote } from '@ionic/angular/standalone';
import {SexyModule} from '@qid/sexy';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadingController} from "@ionic/angular/standalone";
import {CreateMasterTemplateDto} from '../../dto/create-master-template.dto';
import {MasterTemplate} from '../../models/MasterTemplate';
import {MasterTemplateService} from '../../components/services/master-template.service';
import {Industry, IndustryService} from "../../../industry";

@Component({
  selector: 'app-view-master-template',
  templateUrl: './view-master-template.page.html',
  styleUrls: ['./view-master-template.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonTitle,
    IonButton,
    IonIcon,
    IonContent,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonNote
  ]
})
export class ViewMasterTemplatePage implements OnInit {
  public masterTemplate: MasterTemplate;
  public industries: Industry[] = [];

  constructor(
    private router: Router,
    private masterTemplateService: MasterTemplateService,
    private activatedRoute: ActivatedRoute,
    private industryService: IndustryService,
    private loadingController: LoadingController
  ) {
  }

  ngOnInit() {
    this.fetchRouterData();
  }

  public async fetchRouterData() {
    const templateId =
      this.activatedRoute.snapshot.paramMap.get('masterTemplateId');
    await this.viewTemplate(templateId);
    this.fetchAllIndustries();
  }

  private async viewTemplate(templateId: string) {
    if (!templateId) {
      return;
    }
    this.masterTemplate = await this.masterTemplateService.read(templateId);
  }

  public async deleteTemplate(templateId: string) {
    await this.masterTemplateService.delete(templateId);
    this.router.navigateByUrl('menu/list-master-template');
  }

  public async fetchAllIndustries() {
    this.industries = await this.industryService.readAll()
  }

  async editTemplate() {
    const template = this.masterTemplate.template
    this.router.navigate(['menu', 'templates', template._id]);
  }

  async updateMasterTemplate() {
    let dto = new CreateMasterTemplateDto()
    for (let industry of this.masterTemplate.industries) {
      if (industry._id != null) {
        dto.industries.push(industry._id)
      }
    }
    let loader = await this.loadingController.create()
    loader.present();
    const response = await this.masterTemplateService.update(dto, this.masterTemplate._id)
    loader.dismiss();
    if (response) {
      this.masterTemplate = response
    }
  }

  isIndustrySelected(industry: Industry): boolean {
    if (!this.masterTemplate) {
      return false
    }
    for (let ind of this.masterTemplate.industries) {
      if (ind._id == industry._id) {
        return true;
      }
    }
    return false
  }

  onIndustryToggle(event, industry: Industry) {
    let index = -1;
    let loopIndex = 0;
    for (let ind of this.masterTemplate.industries) {
      if (ind._id == industry._id) {
        index = loopIndex;
        break;
      }
      loopIndex++;
    }

    index < 0 ?
      this.masterTemplate.industries.push(industry) :
      this.masterTemplate.industries.splice(index, 1);

    this.updateMasterTemplate();

  }

}
